import { GTM_ENABLED, GTM_ID, updateConsent } from '@/lib/gtag';
import Script from 'next/script';
import { useEffect } from 'react';
import { getCookieConsentValue } from 'react-cookie-consent';

export function GoogleTag() {
  const cookieConsent = getCookieConsentValue();

  // Apply the choice of returning visitors. New choices are applied straight
  // from the cookie popup's buttons.
  useEffect(() => {
    if (cookieConsent === 'true') {
      updateConsent(true);
    } else if (cookieConsent === 'false') {
      updateConsent(false);
    }
  }, [cookieConsent]);

  if (!GTM_ENABLED) {
    return null;
  }

  return (
    <>
      {/* Consent defaults, set before GTM loads so its tags respect them */}
      <Script
        id="gtag-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}

                gtag('consent', 'default', {
                    'ad_storage': 'denied',
                    'ad_user_data': 'denied',
                    'ad_personalization': 'denied',
                    'analytics_storage': 'denied'
                })
            `,
        }}
      />
      {/* Google Tag Manager */}
      <Script
        id="google-tag-manager"
        type="text/javascript"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','${GTM_ID}');`,
        }}
      />
      {/* End Google Tag Manager */}
    </>
  );
}
